export enum AuthStrategy {
	ANONYMOUS = 'anonymous',
	CREDENTIALS = 'credentials',
	APPLE = 'apple',
	FACEBOOK = 'facebook',
	GOOGLE = 'google'
}
